import { render, staticRenderFns } from "./SubmitAction.vue?vue&type=template&id=48744dce&scoped=true"
import script from "./SubmitAction.vue?vue&type=script&lang=ts"
export * from "./SubmitAction.vue?vue&type=script&lang=ts"
import style0 from "./SubmitAction.vue?vue&type=style&index=0&id=48744dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48744dce",
  null
  
)

export default component.exports